import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { surfaceStore } from 'owa-calendar-surface-surface-store';
import {
    CalendarSurfaceItemsConfig,
    isOverflowIndicatorId,
    createMonthItemsDecorator,
    createDragHelperDecorator,
    createItemsDecorator,
} from 'owa-calendar-surface-dategrid';
import { isDragItemId } from 'owa-calendar-surface-dategrid-common-dnd';
import { createMonthDayCellsDecorator } from 'owa-calendar-surface';
import {
    owaCalendarItemsEventHandlers,
    monthDayCellsEventHandlers,
    monthOverflowItemsHandlers,
    weekOverflowItemsHandlers,
} from './OwaCalendarSurfaceEventHandlers';
import { monthItemTemplate, overflowMonthItemTemplate } from './OwaMonthTemplates';
import { getDayGridItemConfig } from 'owa-day-grid/lib/components/DayGridItemConfig';
import { getCalendarEventColorScheme } from 'owa-calendar-color-resolver';
import { isCalendarPeekShown } from 'owa-calendar-module-command';

const monthItemsDecorator = createMonthItemsDecorator(surfaceStore);
const monthOverflowItemsDecorator = createItemsDecorator(surfaceStore);
const monthDragHelperDecorator = createDragHelperDecorator(surfaceStore);

/**
 * Gets item configuration for given calendar event
 */
export const getDayWeekItemConfig = getDayGridItemConfig(
    surfaceStore,
    owaCalendarItemsEventHandlers,
    weekOverflowItemsHandlers,
    getCalendarEventColorScheme,
    true /* joinButtonVisible */,
    isCalendarPeekShown /* shouldHideTooltip */
);

export function getMonthItemConfig(model: CalendarEvent): CalendarSurfaceItemsConfig {
    if (isOverflowIndicatorId(model.ItemId.Id)) {
        return monthOverflowItemsConfig;
    }
    if (isDragItemId(model.ItemId.Id)) {
        return dragDropMonthItemConfig;
    }
    return monthItemsConfig;
}

/**
 * Configuration for month items
 */
const monthItemsConfig: CalendarSurfaceItemsConfig = {
    itemsEventHandlers: owaCalendarItemsEventHandlers,
    itemsDecorator: monthItemsDecorator,
    template: monthItemTemplate,
};

/**
 * Configuration for overflow items in month view
 */
const monthOverflowItemsConfig: CalendarSurfaceItemsConfig = {
    itemsEventHandlers: monthOverflowItemsHandlers,
    itemsDecorator: monthOverflowItemsDecorator,
    template: overflowMonthItemTemplate,
};

/**
 * Configuration for drag and drop items in month view
 */
const dragDropMonthItemConfig: CalendarSurfaceItemsConfig = {
    itemsDecorator: monthDragHelperDecorator,
    template: monthItemTemplate,
};

/**
 * Configuration for month day cells
 */
export const monthDayCellConfig = {
    itemsEventHandlers: monthDayCellsEventHandlers,
    itemsDecorator: createMonthDayCellsDecorator(surfaceStore),
};
